import styled from '@emotion/styled'

export const Section = styled.section`
	flex: 1;
	max-height: 100%;
	overflow: auto;
`
